import z from 'zod'

export const CompleteCartSchema = z.object({
    cart_id: z.string().min(1),
})
